import http from '../../axios-config/g-http-metodos';

function GetChecklistAmostraLote(objFiltro) {
  const { res, erro, requisicao } = http.postArray('/ChecklistAmostraLote/GetChecklistAmostraLote', objFiltro)
  return { ChecklistArray: res , erro, requisicao }
}

function GetChecklistAmostraLoteById(checkListAmostraSelecionada) {
  const { res, erro, requisicao } = http.getArray('/ChecklistAmostraLote/GetChecklistAmostraLoteById', checkListAmostraSelecionada)
  return { ChecklistArray: res , erro, requisicao }
}

const CheckListAmostraController = {
  GetChecklistAmostraLoteById,
  GetChecklistAmostraLote,
}

export default CheckListAmostraController;
